<div class="c-name min-w-0 flex flex-row items-center gap-3">

  <div class="flex min-w-0 items-center gap-3">
    <img class="size-12 shrink-0 rounded-md bg-zinc-100 object-cover dark:bg-zinc-800"
      [src]="imageService.getImageSource(brief().product.image, 'gallery')" [alt]="brief().product.name" />
  </div>

  <div class="flex min-w-0 flex-col gap-1">
    <p class="m-0 truncate font-bold text-lg leading-tight use-grotesque text-zinc-950 dark:text-zinc-50">{{
      brief().name
      }}</p>
    <p class="m-0 mt-1 flex min-w-0 items-center gap-1.5 truncate text-xs text-zinc-500 dark:text-zinc-400">
      <span class="grid size-5 shrink-0 place-items-center rounded-full text-xs font-bold leading-none text-white"
        [style.background]="avatarColor(brief().owner?.id || brief().id)" aria-hidden="true">{{
        avatarInitial(brief().owner?.name || ownerText()) }}</span>
      {{ ownerText() }} · {{ brief().product.name }} · Updated {{ updatedLabel(brief().updatedAt) }}
    </p>
  </div>
</div>

<div class="c-type flex min-w-0 flex-col items-start gap-1 text-xs font-semibold text-zinc-600 dark:text-zinc-300">
  <span class="flex min-w-0 items-center gap-1.5">
  <span
    class="grid size-7 shrink-0 place-items-center rounded-lg bg-zinc-100 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-300"
    aria-hidden="true">
    @switch (brief().type) {
    @case ('screening') {
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
      class="size-3.5" aria-hidden="true">
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
      <path d="M11 8v6" />
      <path d="M8 11h6" />
    </svg>
    }
    @case ('monitoring') {
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
      class="size-3.5" aria-hidden="true">
      <path d="M19.07 4.93A10 10 0 0 0 6.99 3.34" />
      <path d="M4 6h.01" />
      <path d="M2.29 9.62A10 10 0 1 0 21.31 8.35" />
      <path d="M16.24 7.76A6 6 0 1 0 8.23 16.67" />
      <path d="M12 18h.01" />
      <path d="M17.99 11.66A6 6 0 0 1 15.77 16.67" />
      <circle cx="12" cy="12" r="2" />
      <path d="m13.41 10.59 5.66-5.66" />
    </svg>
    }
    @default {
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
      class="size-3.5" aria-hidden="true">
      <path d="M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z" />
      <path d="m6.2 5.3 3.1 3.9" />
      <path d="m12.4 3.4 3.1 4" />
      <path d="M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />
    </svg>
    }
    }
  </span>
  <span class="truncate">{{ typeLabel(brief().type) }}</span>
  </span>
  @if (postTypeBrief(); as postBrief) {
  <span [class]="postTypePillClass(postBrief)">{{ postTypeLabel(postBrief) }}</span>
  }
</div>

<div class="c-status">
  <span [class]="statusClass()">
    <span class="size-1.5 rounded-full bg-current" aria-hidden="true"></span>
    {{ statusLabel(brief().status) }}
  </span>
</div>

<div class="c-action min-w-0 text-sm">
  @if (brief().pendingAction; as action) {
  <p class="m-0 flex min-w-0 items-center gap-2 text-sm text-zinc-800 dark:text-zinc-100">
    <span
      [class]="action.kind === 'setup' ? 'size-2 shrink-0 rounded-full bg-zinc-400' : 'size-2 shrink-0 rounded-full bg-primary ring-4 ring-primary/15'"
      aria-hidden="true"></span>
    {{ actionText(action.kind, action.count, brief()) }}
  </p>
  } @else {
  <p class="m-0 text-zinc-400">—</p>
  }
</div>

<p class="c-creators m-0 text-right text-sm tabular-nums text-zinc-800 dark:text-zinc-100"
  [attr.aria-label]="creatorsAria(brief(), requiredFromBrief())">
  {{ creatorsText(brief(), requiredFromBrief()) }}
</p>

<div class="c-ends">
  <p class="m-0 text-sm text-zinc-800 dark:text-zinc-100">{{ endsDisplay(brief()).primary }}</p>
  @if (endsDisplay(brief()).secondary) {
  <p class="m-0 text-xs text-zinc-500">{{ endsDisplay(brief()).secondary }}</p>
  }
</div>

<div class="c-cta relative flex items-center justify-end gap-2" data-briefs-menu>
  @if (brief().pendingAction; as action) {
  @if (actionCommands(brief()); as commands) {
  <a [routerLink]="commands" class="btn-shout btn-shout-xs btn-shout-primary shrink-0" (click)="stop($event)">{{
    actionButton(action.kind, brief()).label }}</a>
  } @else {
  <button type="button"
    [class]="'btn-shout btn-shout-xs shrink-0 ' + (actionButton(action.kind, brief()).outline ? 'btn-shout-tertiary' : 'btn-shout-primary')"
    (click)="emit('setup', $event)">{{ actionButton(action.kind, brief()).label }}</button>
  }
  }

  @if (settingsBrief(); as settingsBrief) {
  <div (click)="stop($event)">
    <briefs-brief-quick-settings class="shrink-0" [brief]="settingsBrief"
      (briefUpdated)="settingsUpdated.emit($event)" />
  </div>
  }

  <button [routerLink]="overviewCommands(brief())" (click)="stop($event)" type="button" position="top"
    class="fab-button-primary">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </svg>
  </button>
</div>